const { DragHandle } = require("@mui/icons-material");

export const VerticalDragIndicator = () => {
  return (
    <div style={{ rotate: "90deg" }}>
      <DragHandle color="#D9D9D9" />
    </div>
  );
};
